var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',_vm._b({class:_vm.iconClass},'i',_vm.$attrs,false),[(_vm.iconText)?[_vm._v(_vm._s(_vm.iconText))]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }